import React from 'react';
import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter } from '@heroui/react';
import { CustomHeroButton, ResponsiveModal, Typography } from '../../../../../components';
import { Icon } from '@iconify/react';
import { IcModalSuccess } from '../../../../../components/icons';
import { useTranslations } from '../../../../../contexts/translation.context';

interface CredentialsSuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const CredentialsSuccessModal: React.FC<CredentialsSuccessModalProps> = ({ isOpen, onClose }) => {
  const { t } = useTranslations();
  return (
    <ResponsiveModal isOpen={isOpen} onClose={onClose}>
      <ModalContent className="md:w-[25rem]">
        <ModalHeader className="flex items-center gap-2">
          <IcModalSuccess />
          <h3 className="text-lg font-medium">{t('accountPage.credentials.modal.title')}</h3>
        </ModalHeader>
        <ModalBody className="pt-3 px-4 md:px-6 pb-6">
          <Typography variant="body2">{t('accountPage.credentials.modal.message')}</Typography>
        </ModalBody>
        <ModalFooter>
          <CustomHeroButton onPress={onClose} title={t('createAccount.buttons.continue')} />
        </ModalFooter>
      </ModalContent>
    </ResponsiveModal>
  );
};

export default CredentialsSuccessModal;
